module.exports = __webpack_public_path__ + "img/weixin_back.fcc700b4.png";